document.addEventListener("DOMContentLoaded", (event) => {
  // Init owl Section Best Sellers
  const sectionBestSellers = document.querySelectorAll('.hoko-best-sellers')
  if (sectionBestSellers.length > 0) {
    sectionBestSellers.forEach(section => {
      const swiperBestSeller = new Swiper(section.querySelector('.swiper'), {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
        centeredSlides: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: section?.querySelector('.swiper-button-next'),
          prevEl: section?.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: section?.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
        on: {
          init: function () {
            const activeIndex = this.activeIndex
            const activeSlide = this.slides[activeIndex]
            const slideDataJSON = JSON.parse(activeSlide.querySelector('script[type="application/json"]').textContent)
            handleInforLabel(section, slideDataJSON)
          },
          slideChange: function () {
            const activeIndex = this.activeIndex
            const activeSlide = this.slides[activeIndex]
            const slideDataJSON = JSON.parse(activeSlide.querySelector('script[type="application/json"]').textContent)
            handleInforLabel(section, slideDataJSON)
          }
        }
      })
    })
  }

  function handleInforLabel(section, slideDataJSON) {
    // Define element DOM
    const elmTitle = section.querySelector('.best-sellers__content-label .label__title-price-title')
    const elmPrice = section.querySelector('.best-sellers__content-label .label__title-price-price')
    const elmPriceCompare = section.querySelector('.best-sellers__content-label .label__title-price-compare')
    const elmSubTitle = section.querySelector('.best-sellers__content-label .label__sub-title')
    const elmLabels = document.querySelector('.best-sellers__content-label .label__product-labels')
    const elmLink = section.querySelector('.best-sellers__content-label .label__link')

    elmTitle.textContent = slideDataJSON.title || ''
    elmPrice.textContent = slideDataJSON.price || ''
    elmPriceCompare.textContent = slideDataJSON.price_sale || ''
    elmSubTitle.textContent = slideDataJSON.sub_title || ''
    elmLink.setAttribute('href', slideDataJSON.url || '')
    elmLabels.innerHTML = ''
    if (slideDataJSON.labels.length > 0) {
      slideDataJSON.labels.map(item => {
        elmLabels.innerHTML += `<span>${item.label}</span>`
      })
    } else {
      elmLabels.innerHTML = ''
    }
  }
})
